import { RETURN_CANDIDATE_TO_POOL } from "@lib/graphql/mutations";
import { useState } from "react";
import { useMutation } from "urql";
import { ReturnToPoolDialog } from "./ReturnToPoolDialog";

interface DemotingTarget {
  campaignCandidateId: string;
  candidateName: string;
  fromStage: string;
}

export function useReturnToPool(onDone: () => void) {
  const [target, setTarget] = useState<DemotingTarget | null>(null);
  const [, returnToPool] = useMutation(RETURN_CANDIDATE_TO_POOL);

  const openFor = (cc: { id: string; candidate: { fullName: string } }, fromStage: string) => {
    setTarget({
      campaignCandidateId: cc.id,
      candidateName: cc.candidate.fullName,
      fromStage,
    });
  };

  const close = () => setTarget(null);

  const handleConfirm = async (reason: string) => {
    if (!target) return;
    await returnToPool({
      input: { campaignCandidateId: target.campaignCandidateId, reason },
    });
    close();
    onDone();
  };

  const dialog = (
    <ReturnToPoolDialog
      open={target !== null}
      candidateName={target?.candidateName ?? ""}
      fromStage={target?.fromStage ?? ""}
      onClose={close}
      onConfirm={handleConfirm}
    />
  );

  return { openFor, dialog };
}
